require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-why-is-it-critical-for-civil-society-to-engage-in-the.json") })
        }
      }, "path---en-us-update-why-is-it-critical-for-civil-society-to-engage-in-the");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-why-is-it-critical-for-civil-society-to-engage-in-the!./.cache/json/en-us-update-why-is-it-critical-for-civil-society-to-engage-in-the.json
// module id = 865
// module chunks = 231608221292675